import { z } from 'zod';

export const ExtendedVenueType = z.enum([
  'BLANK',
  'ENTERTAINMENT_VENUE',
  'AQUARIUM_ZOO',
  'ARENA_STADIUM',
  'BANQUET_FACILITY',
  'CONFERENCE_CENTER',
  'CONVENTION_CENTER',
  'CORPORATE_OFFICE_SPACE',
  'EDUCATIONAL_FACILITY',
  'EXPOSITION_CENTER',
  'GALLERY_MUSEUM',
  'GOLF_COURSE',
  'HOTEL',
  'MOVIE_THEATRE',
  'RESORT',
  'RESTAURANT',
  'SPECIAL_EVENT_VENUE',
  'LUXURY_HOTEL',
  'CVB',
  'DMC',
  'BOUTIQUE_HOTEL',
  'BAR_CLUB',
  'INTERNAL_VENUE'
]);

export type ExtendedVenueType = z.infer<typeof ExtendedVenueType>;
